<template>
  <div v-cloak>

    <div class="header" style="position: sticky;top: 0;height: 65px;z-index: 999">
      <el-row>
        <el-col :span="24">
          <div class="header">
            <el-menu
                :default-active="activeIndex"
                mode="horizontal"
                :active-text-color="activeIndex"
                :router="true"
                text-color="#818184"
            >

              <el-menu-item index="1" route="/">
                <div>
                  <router-link :to="{name: 'index'}"><h3 style="color: #82a9ff">Clem集团</h3></router-link>
                </div>
              </el-menu-item>

              <el-menu-item index="2" route="/">
                <div id="index">
                  <router-link :to="{name: 'index'}" :style="{color:$store.state.colorIndex}">主页</router-link>
                </div>
              </el-menu-item>

              <el-menu-item index="3" route="clemblog">
                <div id="blog">
                  <router-link :to="{name: 'blog'}" :style="{color:$store.state.colorBlog}">博客</router-link>
                </div>
              </el-menu-item>

              <el-menu-item index="4" route="clemcontact">
                <div id="contact">
                  <router-link :to="{name: 'contact'}" :style="{color:$store.state.colorContact}">联系我们</router-link>
                </div>
              </el-menu-item>

              <el-submenu index="5">
                <template slot="title">更多</template>

                <el-menu-item index="2-1" style="height: 55px" route="/">
                  <el-menu-item index="1">
                    <audio controls="controls" height="100" width="100">
                      <source src="./assets/mp3/xixi.mp3" type="audio/mp3" />
                      <source src="./assets/mp3/xixi.mp3" type="audio/ogg" />
                      <embed height="100" width="100" src="./assets/mp3/xixi.mp3" />
                    </audio>
                  </el-menu-item>
                </el-menu-item>

                <hr style="height: 1px;border: 1px solid #004aff;background-color: #004aff">

                <router-link :to="{name: 'coreteamlist'}">
                  <el-menu-item index="2-2" route="coreteamlist">
                    <h2 style="text-align: center;color: #000000">
                      🏢核心团队
                    </h2>
                  </el-menu-item>
                </router-link>
                <hr style="height: 1px;border: 1px solid #fc8eeb;background-color: #fc8eeb">

                <el-menu-item index="2-3" @click="fei">
                  <h2 style="text-align: center;color: #000000">
                    ⚙管理员登录🛠
                  </h2>
                </el-menu-item>

              </el-submenu>

            </el-menu>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="main">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>

    <div class="footer">
        <h4>©版权所有Clem 集团</h4>
    </div>


  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data(){
    return{
      activeIndex: '0',
    }
  },
  methods: {
    fei(){
      window.location.href = "http://121.40.117.227/admin/#/";
    }
  },
  computed: {

  },

  beforeCreate() {

    //解决手机端和电脑端用户访问，切换
    // if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    //   window.location.href = "http://192.168.36.50:8081/clemphone/";
    // } else {
    //   console.log("PC端用户，欢迎~");
    // }

  }
}
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
}
[v-cloak] {
  display: none;
}
a {
  text-decoration: none;
}
#index:hover{
  color: #000000;
}
#blog:hover{
  color: #000000;
}
#contact:hover{
  color: #000000;
}

body {
  background-color: skyblue;
}

.header {

}
.main {

}
.footer {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #797979;
  background-color: #d9fffd;
}

</style>
